import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProtoolsComponent } from './simple-icons-protools.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProtoolsComponent ],
    exports:      [ SimpleIconsProtoolsComponent ],
    bootstrap:    []
})
export class SimpleIconsProtoolsModule {}
